__webpack_require__.p = "/dist/RemoteOrder/js/components/customizer/";